module.exports = __webpack_public_path__ + "img/AssociationLineEndIcon2.24b37a82.svg";